export type { ExplorerMode, ExplorerQueryParams } from '@vscode/component-explorer-cli/explorer-types';

export function parseExplorerQueryParams(params: URLSearchParams): ExplorerQueryParams {
    const mode = params.get('mode');
    return {
        mode: mode === 'headless' || mode === 'embedded' ? mode : undefined,
        fixture: params.get('fixture') ?? undefined,
        file: params.get('file') ?? undefined,
        report: params.get('report') ?? undefined,
    };
}

export function toUrlSearchParams(query: ExplorerQueryParams): URLSearchParams {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(query)) {
        if (value !== undefined) params.set(key, String(value));
    }
    return params;
}
